import { __awaiter } from "tslib";
import { SPRest } from "../rest.js";
import { Web } from "../webs/types.js";
import "./web.js";
import { SharePointQueryable } from "../sharepointqueryable.js";
export { App, AppCatalog, } from "./types.js";
SPRest.prototype.getTenantAppCatalogWeb = function () {
    return __awaiter(this, void 0, void 0, function* () {
        return this.childConfigHook(({ options, runtime }) => __awaiter(this, void 0, void 0, function* () {
            const data = yield SharePointQueryable("/", "_api/SP_TenantSettings_Current").configure(options).setRuntime(runtime)();
            return Web(data.CorporateCatalogUrl).configure(options).setRuntime(runtime);
        }));
    });
};
//# sourceMappingURL=index.js.map